export const DELAY_TO_SHOW_SONG_INFO = 1;
